import type { FileRecord } from './index.ts';

/** Stable identity of an item in the user-owned library. */
export type LibraryItemKind = 'file' | 'thread' | 'folder';
export interface LibraryItemRef { kind: LibraryItemKind; id: string }

/** A user-created folder or the permanent Conversations folder. */
export interface LibraryFolder {
  id: string;
  name: string;
  createdAt: string;
  /** Relative to /workspace/library. The Conversations collection uses an empty path. */
  relativePath: string;
  sandboxPath: string;
  system?: 'conversations';
}

/** Parent mirrors the real file tree; position is the user's display order. */
export interface LibraryLocation extends LibraryItemRef {
  parentId: string | null;
  position: number;
}

export interface LibrarySnapshot {
  revision: number;
  folders: LibraryFolder[];
  locations: LibraryLocation[];
  files: FileRecord[];
}

export interface LibraryMoveRequest {
  entry: LibraryItemRef;
  parentId: string | null;
  before?: LibraryItemRef | null;
  revision: number;
}

export interface LibraryCreateFolderRequest {
  name: string;
  parentId: string | null;
  revision: number;
}

export const LIBRARY_CONVERSATIONS_ID = 'conversations' as const;
